export { parseMessage, buildMessage } from './messages.js';
export { getApiState } from './get-api-state.js';
export { PlayState, PlayerState, ErrorCode, ErrorDescription } from './enums.js';
export { mapOldLayoutOptions } from './map-old-layout-options.js';

export const BROKER_ACTIVATION_DATA = Object.freeze({
    version: Object.freeze({
        version: '8.12',
        supports: ["6.1.5", "6.1.7", "6.1.9", "6.1.11", "7.0", "7.0.28", "7.0.29", "7.2", "7.2.2", "7.2.2a", "7.4.0", "8.12"],
        application: 'MediasitePlayer'
    })
});
